import React, { useEffect, useState } from 'react';
import Hero from '../common/Hero';
import Footer from '../common/Footer';
import { initAnimations } from '../../utils/animations';
import About1 from '../../assets/images/harvey5.jpg';
import About2 from '../../assets/images/harvey1.jpeg';
import About3 from '../../assets/images/harvey2.jpeg';

import Event1 from '../../assets/images/events-1.jpg'
import Event2 from '../../assets/images/events-2.jpg'
import Event3 from '../../assets/images/events-3.jpg'
// import Child from "../../assets/images/about-child.jpg"



const Home = () => {

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    initAnimations();
  }, []);
  const [todayPrayer, setTodayPrayer] = useState(null);
  const [nextPrayer, setNextPrayer] = useState(null);


  const dummyPrayerResponse = {
    status: 1,
    msg: 'Prayer times fetched successfully.',
    data: {
      month: 'June',
      year: '2025',
      days: [
        {
          date: '27',
          day: 'Fri',
          Fajr: { azanTime: '3:39 AM', salatTime: '4:19 AM' },
          Dhuhr: { azanTime: '12:48 PM', salatTime: '1:28 PM' },
          Asr: { azanTime: '4:49 PM', salatTime: '5:29 PM' },
          Maghrib: { azanTime: '8:21 PM', salatTime: '8:54 PM' },
          Isha: { azanTime: '9:58 PM', salatTime: '10:30 PM' },
        },
      ]
    }
  };

  useEffect(() => {
    const fetchPrayerTimes = async () => {
      try {
        const now = new Date();
        const monthNames = ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"];
        const currentMonth = monthNames[now.getMonth()];
        const currentYear = now.getFullYear();

        const response = await fetch(
          `https://backend.harveymasjid.com/api/prayer/getPrayerTimes?month=${currentMonth}&year=${currentYear}`,
          {
            method: 'GET',
            headers: {
              'Authorization': 'Basic ' + btoa(process.env.REACT_APP_NAME + ':' + process.env.REACT_APP_PASS),
              'Content-Type': 'application/json',
            },
          }
        );

        const data = await response.json();
        if (data.status === 1) {
          const today = new Date();
          const todayDate = today.getDate().toString(); // e.g., "27"

          const todayData = data.data.days.find(day => day.date === todayDate);
          if (todayData) {
            setTodayPrayer(todayData);
            findUpcomingPrayer(todayData);
            console.log(todayData)
          }
        }
      } catch (error) {
        console.error('Failed to fetch prayer times:', error);
      }
    };

    const findUpcomingPrayer = (prayers) => {
      const now = new Date();

      const to24HourTime = (timeStr) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        if (modifier === 'PM' && hours !== 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
      };

      const prayerOrder = ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'];
      for (const name of prayerOrder) {
        const salatTime = to24HourTime(prayers[name].salatTime);
        if (now < salatTime) {
          setNextPrayer(name);
          break;
        }
      }
    };

    fetchPrayerTimes();
  }, []);



  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('https://backend.harveymasjid.com/api/event/getAllEvent', {
          method: 'GET',
          headers: {
            'Authorization': 'Basic ' + btoa(process.env.REACT_APP_NAME + ':' + process.env.REACT_APP_PASS),
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch events');
        }

        const data = await response.json();
        if (data.status === 1) {
          setEvents(data.events);
        } else {
          throw new Error(data.msg || 'Failed to retrieve events');
        }
      } catch (err) {
        setError(err.message);
        // Fallback to default events if API fails
        setEvents([
          {
            _id: "1",
            title: "Ramadan Preparation Workshop",
            description: "Join us for an informative session on how to maximize your Ramadan experience. Learn about spiritual preparation, healthy fasting practices, and making the most of the blessed month. Open to all community members.",
            date: "2024-03-15T18:30:00.000Z"
          },
          {
            _id: "2",
            title: "Youth Leadership Retreat",
            description: "A weekend program for Muslim youth ages 13-18 focusing on developing leadership skills, Islamic identity, and community service. Includes workshops, team-building activities, and outdoor recreation.",
            date: "2024-03-22T10:00:00.000Z"
          },
          {
            _id: "3",
            title: "Islamic Finance Seminar",
            description: "Learn about Islamic principles of finance, halal investing, and debt-free living from renowned Islamic finance experts. This event is particularly valuable for young professionals and families.",
            date: "2024-04-05T19:00:00.000Z"
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  // Default images array to cycle through if no images from API
  const eventImages = [Event1, Event2, Event3];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'short', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleTimeString('en-US', options).replace(',', '');
  };

  if (loading) {
    return <div className="container-fluid event py-5">
      <div className="container py-5 text-center">Loading events...</div>
    </div>;
  }

  if (error) {
    console.error(error);
  }

  const renderCard = (name, times) => {
    const isNext = name === nextPrayer;

    return (
      <div key={name} className="col-md-6 col-lg-4">
        <div className={`rounded-4 p-4 shadow-sm text-white ${isNext ? 'bg-success' : 'bg-purple'}`}>
          <h5 className="mb-3 fw-bold">{name}</h5>
          <div className="d-flex justify-content-between fs-6">
            <span>Starts</span>
            <span>{times.azanTime}</span>
          </div>
          <div className="d-flex justify-content-between fs-6">
            <span>Iqamah</span>
            <span>{times.salatTime}</span>
          </div>
        </div>
      </div>
    );
  };



  return (
    <>
      <Hero
        title="Welcome"
        subtitle="South Suburban Islamic Center of Harvey"
        pageName="home"
      />

      {/* About Section */}
      <div className="container-fluid about py-5">
        <div className="container py-5">
          <div className="container bg-primary py-5 text-white rounded shadow wow fadeIn" data-wow-delay="0.1s">
            <div className="row align-items-center g-4">
              {/* Icon */}
              <div className="col-md-2 text-center">
                <i className="fa fa-mosque fa-4x"></i>
              </div>

              {/* Message and Jummah Time */}
              <div className="col-md-7 text-center text-md-start">
                <h2 className="mb-2 fw-bold">
                  Jummah Namaz every Friday at 1:30 PM
                </h2>

              </div>

              {/* Button */}
              <div className="col-md-3 text-center text-md-end">
                <a href="#/about" className="btn btn-light text-primary fw-semibold px-4 py-2 rounded-pill shadow-sm">
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div className="container my-5 px-4 py-5 bg-white rounded-4 shadow-lg text-center text-md-start">
            <h2 className="mb-4 fw-bold text-dark text-center display-6">Today's Prayer Times</h2>

            {todayPrayer ? (
              <div className="row gy-4">
                {renderCard('Fajr', todayPrayer.Fajr)}
                {renderCard('Dhuhr', todayPrayer.Dhuhr)}
                {renderCard('Asr', todayPrayer.Asr)}
                {renderCard('Maghrib', todayPrayer.Maghrib)}
                {renderCard('Isha', todayPrayer.Isha)}
              </div>
            ) : (
              <p className="text-secondary fs-5 text-center">Loading prayer times...</p>
            )}

            {/* Optional Jummah Card */}

          </div>
          <div className="row g-5 mb-5">
            <div className="col-xl-6">
              <div className="row g-4">
                <div className="col-6">
                  <img
                    src={About1}
                    className="img-fluid  wow zoomIn"
                    data-wow-delay="0.1s"
                    alt="Harvey Masjid Exterior"
                  />
                </div>
                <div className="col-6">
                  <img
                    src={About2}
                    className="img-fluid  wow zoomIn"
                    data-wow-delay="0.1s"
                    alt="Prayer Hall"
                  />
                  <img
                    src={About3}
                    className="img-fluid pt-3 wow zoomIn"
                    data-wow-delay="0.1s"
                    alt="Islamic Classes"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-6 wow fadeIn" data-wow-delay="0.5s">
              <p className="fs-5 text-uppercase text-primary">About Our Masjid</p>
              <h1 className="display-5 pb-4 m-0">Serving the Muslim Community</h1>
              <p className="pb-4">
                Harvey Masjid has been a cornerstone of the Muslim community in Harvey,
                providing spiritual guidance, education, and social services for nearly three decades.
                Our mission is to foster an environment of worship, learning, and community building
                in accordance with Islamic principles.
              </p>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="vision-mission-box">
                    <div className="icon-container">
                      <div className="icon-bg">
                        <i className="fa fa-eye"></i>
                      </div>
                    </div>
                    <div className="content">
                      <h5>Our Vision</h5>
                      <p>To be a beacon of Islamic knowledge and values that serves all community members</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="vision-mission-box">
                    <div className="icon-container">
                      <div className="icon-bg">
                        <i className="fa fa-flag"></i>
                      </div>
                    </div>
                    <div className="content">
                      <h5>Our Mission</h5>
                      <p>To provide religious, educational, and social services to Muslims and the wider community</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="bg-light p-3 mb-4">
                <div className="row align-items-center justify-content-center">
                  <div className="col-3">
                    <img src={Child} className="img-fluid rounded-circle" alt="Children Learning" />
                  </div>
                  <div className="col-6">
                    <p className="mb-0">
                      Our weekend Islamic school has educated over 500 children in Quran, Arabic,
                      and Islamic studies since its establishment.
                    </p>
                  </div>
                  <div className="col-3">
                    <h2 className="mb-0 text-primary text-center">$42,850</h2>
                    <h5 className="mb-0 text-center">Raised</h5>
                  </div>
                </div>
              </div> */}
              <div className="row g-2">
                <div className="col-md-6">
                  <p className="mb-2"><i className="fa fa-check text-primary me-3"></i>Daily Prayers & Jumu'ah</p>
                  <p className="mb-0"><i className="fa fa-check text-primary me-3"></i>Quran & Arabic Classes</p>
                </div>
                <div className="col-md-6">
                  <p className="mb-2"><i className="fa fa-check text-primary me-3"></i>Youth Programs</p>
                  <p className="mb-0"><i className="fa fa-check text-primary me-3"></i>Community Services</p>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div >

      {/* Activities Section */}
      < div className="container-fluid activities py-5" >
        <div className="container py-5">
          <div className="mx-auto text-center mb-5 wow fadeIn" data-wow-delay="0.1s" style={{ maxWidth: '700px' }}>
            <p className="fs-5 text-uppercase text-primary">Our Services</p>
            <h1 className="display-3">Community Programs & Services</h1>
          </div>
          <div className="row g-4">
            <div className="col-lg-6 col-xl-4">
              <div className="activities-item p-4 wow fadeIn" data-wow-delay="0.1s">
                <i className="fa fa-mosque fa-4x text-dark"></i>
                <div className="ms-4">
                  <h4>Daily Prayers</h4>
                  <p className="mb-4">
                    We hold the five daily prayers in congregation, including Jumu'ah prayers every Friday
                    with khutbah in English and Arabic.
                  </p>
                  <a href="#" className="btn btn-primary px-3">Prayer Times</a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-4">
              <div className="activities-item p-4 wow fadeIn" data-wow-delay="0.3s">
                <i className="fa fa-donate fa-4x text-dark"></i>
                <div className="ms-4">
                  <h4>Zakat & Sadaqah</h4>
                  <p className="mb-4">
                    We collect and distribute Zakat to those in need and accept Sadaqah donations
                    to support our community programs.
                  </p>
                  <a href="#/donate" className="btn btn-primary px-3">Donate Now</a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-4">
              <div className="activities-item p-4 wow fadeIn" data-wow-delay="0.5s">
                <i className="fa fa-quran fa-4x text-dark"></i>
                <div className="ms-4">
                  <h4>Quran Academy</h4>
                  <p className="mb-4">
                    Our Quran school offers classes for all ages and levels, from basic recitation
                    to advanced tajweed and memorization.
                  </p>
                  <a href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid"

                    target="_blank"
                    rel="noopener noreferrer" className="btn btn-primary px-3">Enroll Now</a>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-6 col-xl-4">
              <div className="activities-item p-4 wow fadeIn" data-wow-delay="0.1s">
                <i className="fa fa-book fa-4x text-dark"></i>
                <div className="ms-4">
                  <h4>Islamic Studies</h4>
                  <p className="mb-4">
                    Weekly classes on Islamic beliefs, jurisprudence, Seerah, and Hadith studies
                    for adults and youth.
                  </p>
                  <a href="#" className="btn btn-primary px-3">View Schedule</a>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-6 col-xl-4">
              <div className="activities-item p-4 wow fadeIn" data-wow-delay="0.3s">
                <i className="fa fa-book-open fa-4x text-dark"></i>
                <div className="ms-4">
                  <h4>Family Programs</h4>
                  <p className="mb-4">
                    Marriage counseling, parenting workshops, and family activities to strengthen
                    Muslim families.
                  </p>
                  <a href="#" className="btn btn-primary px-3">Learn More</a>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-6 col-xl-4">
              <div className="activities-item p-4 wow fadeIn" data-wow-delay="0.5s">
                <i className="fa fa-hands fa-4x text-dark"></i>
                <div className="ms-4">
                  <h4>Outreach Services</h4>
                  <p className="mb-4">
                    Food pantry, counseling services, and interfaith dialogue programs serving
                    the wider community.
                  </p>
                  <a href="#" className="btn btn-primary px-3">Get Involved</a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div >

      {/* Events Section */}
      {/* <div className="container-fluid event py-5">
        <div className="container py-5">
          <h1 className="display-3 mb-5 wow fadeIn" data-wow-delay="0.1s">
            Upcoming <span className="text-primary">Events</span>
          </h1>

          {events.length === 0 ? (
            <p>No upcoming events found.</p>
          ) : (
            events.map((event, index) => (
              <div key={event._id} className="row g-4 event-item wow fadeIn" data-wow-delay={`${0.1 + (index * 0.2)}s`}>
                <div className="col-3 col-lg-2 pe-0">
                  <div className="text-center border-bottom border-dark py-3 px-2">
                    <h6>{formatDate(event.date)}</h6>
                    <p className="mb-0">{formatTime(event.time || event.date)}</p>
                  </div>
                </div>
                <div className="col-9 col-lg-6 border-start border-dark pb-5">
                  <div className="ms-3">
                    <h4 className="mb-3">{event.title}</h4>
                    <p className="mb-4">{event.description}</p>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid"
                      className="btn btn-primary px-3"
                    >
                      Register Now
                    </a>
                  </div>
                </div>
                <div className="col-12 col-lg-4">
                  <div className="overflow-hidden mb-5">
                    <img
                      src={eventImages[index % eventImages.length]}
                      className="img-fluid w-100"
                      alt={event.title}
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div> */}

      <Footer />
    </>
  );
};

export default Home;